import { ArrowLeft } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import styles from "./StaticPage.module.css";

export default function TermsPage(): JSX.Element {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className={styles.pageWrapper} data-theme={theme}>
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <button className={styles.backButton} onClick={() => navigate('/home')}>
            <ArrowLeft size={20} /> Back to Home
          </button>
          <div className={styles.logo}>xquant</div>
        </div>
      </nav>

      <main className={styles.content}>
        <h1>Terms of Service</h1>
        <p className={styles.lastUpdated}>Last updated: January 2026</p>
        
        <section>
          <h2>Acceptance of Terms</h2>
          <p>
            By accessing or using xquant, you agree to be bound by these Terms of Service. 
            If you do not agree to these terms, please do not use our service.
          </p>
        </section>

        <section>
          <h2>Description of Service</h2>
          <p>
            xquant provides an AI-powered platform for quantitative trading research, 
            including strategy development, backtesting, and analysis tools. Our service 
            is intended for educational and research purposes.
          </p>
        </section>

        <section>
          <h2>Not Financial Advice</h2>
          <p>
            <strong>Important:</strong> xquant does not provide financial, investment, or 
            trading advice. All strategies, backtests, and analyses are for informational 
            and educational purposes only. Past performance does not guarantee future results. 
            You should consult with a qualified financial advisor before making any investment 
            decisions.
          </p>
        </section>

        <section>
          <h2>User Responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>Provide accurate account information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Use the service in compliance with applicable laws</li>
            <li>Not attempt to reverse engineer or exploit the platform</li>
          </ul>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            The xquant platform, including its design, features, and content, is protected 
            by intellectual property laws. You retain ownership of any strategies or data you 
            create using our platform.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            xquant is provided "as is" without warranties of any kind. We are not liable 
            for any trading losses, damages, or other consequences resulting from your use 
            of our platform or reliance on information provided through our service.
          </p>
        </section>

        <section>
          <h2>Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of the service after 
            changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Questions about these Terms? Contact us at{' '}
            <a href="mailto:aiquant100@gmail.com">aiquant100@gmail.com</a>
          </p>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>© {new Date().getFullYear()} xquant — All rights reserved.</p>
      </footer>
    </div>
  );
}
